import { FORM_PATHS, openInModalOrPage } from '../../modals';
import { createFakeId } from '../../../reducers/util';

export const createPerson = companyId => (dispatch, getState) => {
    dispatch(openInModalOrPage(FORM_PATHS.EditPerson, createFakeId(), {} /*newPerson.personId,newPerson*/, companyId));
};
